import { CMMBranch } from '@fruitful/types';

import { type OnboardingResultsSlideConfig } from '../types';
import BillsSlide from './BillsSlide';
import GoalsSlide from './GoalsSlide';
import InvestingCtaSlide from './InvestingCtaSlide';
import InvestmentsOverviewSlide from './InvestmentsOverviewSlide';
import InvestmentWaterfallSlide from './InvestmentWaterfallSlide';
import MoneyMapSlide from './MoneyMapSlide';
import SpendSlide from './SpendSlide';
import WhyInvestSlide from './WhyInvestSlide';

export const DEFAULT_RESULTS_SLIDES: readonly OnboardingResultsSlideConfig[] = [
    {
        name: 'Money Map',
        Component: MoneyMapSlide,
    },
    {
        name: 'Bills',
        Component: BillsSlide,
    },
    {
        name: 'Spend',
        Component: SpendSlide,
    },
    {
        name: 'Goals',
        Component: GoalsSlide,
    },
];

const INVESTING_RESULTS_SLIDES: readonly OnboardingResultsSlideConfig[] = [
    {
        name: 'Investment Waterfall',
        Component: InvestmentWaterfallSlide,
    },
    {
        name: 'Investments at Fruitful',
        Component: InvestmentsOverviewSlide,
    },
    {
        name: 'Why invest at Fruitful',
        Component: WhyInvestSlide,
    },
    {
        name: 'Put it into action',
        Component: InvestingCtaSlide,
    },
];

export function getResultsSlides(
    branch?: CMMBranch | null,
): readonly OnboardingResultsSlideConfig[] {
    if (branch === CMMBranch.StartInvesting) return INVESTING_RESULTS_SLIDES;
    return DEFAULT_RESULTS_SLIDES;
}
